import { Pipe, PipeTransform, inject, ChangeDetectorRef } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { translation } from '@cue/translations';
import { takeUntil } from 'rxjs';
import { injectDestroy } from 'ngxtension/inject-destroy';

@Pipe({
  name: 'subjectPipe',
  standalone: true,
  pure: false,
})
export class SubjectPipe implements PipeTransform {
  terminator = injectDestroy();
  translocoService = inject(TranslocoService);
  private cdr = inject(ChangeDetectorRef);

  _translationValue = '';

  constructor() {
    this._translationValue = this.translocoService.translate(translation.outlookAddin.noSubject);
    this.translocoService.langChanges$.pipe(takeUntil(this.terminator)).subscribe(() => {
      this._translationValue = this.translocoService.translate(translation.outlookAddin.noSubject);
      this.cdr.markForCheck();
    });
  }

  transform(subject: string | null): string {
    const toCoalesce = subject == null || subject === '';

    if (!toCoalesce) {
      return subject;
    }
    return this._translationValue;
  }
}
